import {
  // GET SETTING
  GET_SETTING,
  GET_SETTING_SUCCESS,
  GET_SETTING_FAILED,
} from './actionTypes';

const initialState = {
  isLoadingGetSetting: false,

  setting: {},
};

export default function setting(state = initialState, action) {
  switch (action.type) {
    case GET_SETTING:
      return {
        ...state,
        isLoadingGetSetting: true,
      };

    case GET_SETTING_SUCCESS:
      return {
        ...state,
        isLoadingGetSetting: false,
        setting: action.payload,
      };

    case GET_SETTING_FAILED:
      return {
        ...state,
        isLoadingGetSetting: false,
      };

    default:
      return state;
  }
}
